/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    ChangePasswordWebData: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.ChangePasswordWebAction.REQUEST_CHANGEPASSWORDWEB:
      return {
        ...state
      };
    case actions.ChangePasswordWebAction.CHANGEPASSWORDWEB_RECEIVED:
      return {
        ...state,
        ChangePasswordWebData: action.data
      };

    default:
      return state;
  }
};

export default reducer;
